<div class="gl-page">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Exportdefinitie</h1>

    <div class="gl-page__header-actions">
      <yds-button (click)="openCopyDialog()">
        Kopiëren exportdefinitie
      </yds-button>
      <yds-button variant="primary" (click)="navigateToCreate()">
        Exportdefinitie toevoegen
      </yds-button>
    </div>
  </div>

  @if (isLoading()) {
    <yds-card>
      <div class="gl-list-state">
        <yds-spinner [label]="'Exportdefinities laden...'" />
      </div>
    </yds-card>
  } @else if (tableItems().length === 0) {
    <yds-empty-states [message]="'Er zijn nog geen exportdefinities'" />
  } @else {
    <yds-card>
      <div class="gl-list-table">
        <yds-table
          [embedded]="true"
          [showPaginationFooter]="rows().length > 0"
          [columns]="tableColumns"
          [items]="tableItems()"
          [zebra]="true"
          [dottedColumns]="true"
          [clickable]="true"
          (rowClick)="onTableRowClick($event)"
        >
          <ng-template ydsTableCell="actions" let-item="item">
            <yds-split-button
              label="Bekijk details"
              [items]="splitButtonItems"
              variant="default"
              size="sm"
              (mainClick)="viewItem(item.id, $event)"
              (itemClick)="handleActionClick(item.id, $event)"
            ></yds-split-button>
          </ng-template>

          @if (rows().length > 0) {
            <yds-pagination
              pagination
              [(pageIndex)]="pageIndex"
              [pageSize]="pageSize"
              [totalItems]="rows().length"
            />
          }
        </yds-table>
      </div>
    </yds-card>
  }

  <app-exportrule-dialog
    [(open)]="dialogOpen"
    [exportDefinitionId]="dialogDefinitionId()"
    [kindOptions]="kindOptions()"
    [headerLevelOptions]="headerLevelOptions()"
    [existingKinds]="dialogExistingKinds()"
    (saved)="onRuleSaved()"
  />

  <app-exportdefinitioncopy-dialog [(open)]="copyDialogOpen" (copied)="onCopied($event)" />
</div>
